// extracted by mini-css-extract-plugin
export var borderRadius = "_g4-4";
export var large = "_g4-3";
export var logoContainer = "_g4-0";
export var nameLogo = "_g4-2";
export var small = "_g4-1";